import React, { VFC } from 'react'
import styled from 'styled-components'

import { Button } from '@Components/Button'
import { down } from '@Globals/Style/breakpoints'

const StyledAnchor = styled.a`
  ${down('tablet')} {
    width: 100%;
  }

  margin-bottom: 50px;
  display: flex;
  justify-content: center;
`
export type LinkColor = 'primary' | 'dark' | 'white'

export interface LinkProps {
  className?: string
  color: LinkColor
  id?: string
  newTab: boolean
  text: string
  url: string
}

export const Link: VFC<LinkProps> = ({
  className,
  color,
  id,
  newTab,
  text,
  url,
}) => (
  // TODO: Navigation event
  <StyledAnchor className={className} href={url} id={id} target={newTab ? '_blank' : undefined}>
    <Button color={color}>
      {text}
    </Button>
  </StyledAnchor>
)
